import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Eye, EyeOff } from "lucide-react";
import { Logo } from "../components/Logo";
import { Spinner } from "../components/common";
import { Field } from "./Login";
import { api, errMsg } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      nav("/login", { replace: true });
    } catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen w-full flex justify-center bg-background">
      <div className="w-full max-w-md bg-mesh min-h-screen px-6 pt-10 pb-10 flex flex-col">
        <Logo size={36} />
        <div className="mt-10 animate-fade-up">
          <h1 className="font-display text-4xl font-light tracking-tighter">New password</h1>
          <p className="text-muted-foreground mt-2">Choose a new password for your account.</p>
        </div>
        {!token ? (
          <p className="mt-8 text-destructive text-sm">Invalid reset link. Please request a new one.</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <Field icon={Lock} type={show ? "text" : "password"} required placeholder="New password" data-testid="reset-password-input"
              value={password} onChange={(e) => setPassword(e.target.value)}
              right={<button type="button" onClick={() => setShow(!show)} className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button>} />
            <button type="submit" disabled={busy} data-testid="reset-submit-btn"
              className="w-full h-14 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center shadow-[0_12px_32px_rgba(75,35,204,0.3)] transition-transform duration-200 active:scale-[0.98] disabled:opacity-60">
              {busy ? <Spinner className="w-5 h-5" /> : "Reset password"}
            </button>
          </form>
        )}
        <Link to="/login" data-testid="back-to-signin-link" className="text-center text-sm text-primary font-semibold mt-auto pt-8">Back to sign in</Link>
      </div>
    </div>
  );
}
